import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { EmployeeConsultantsService } from 'src/app/services/api/hr/employee-consultants.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-employee-consultants-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './employee-consultants-index-page.component.html',
  styleUrl: './employee-consultants-index-page.component.scss'
})
export class EmployeeConsultantsIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected employeeService: EmployeeConsultantsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Personnel',
      cardTitle: 'Manage Personnel',
      addNewItemButton: {
        type: 'success',
        title: 'Add Personnel',
        onClick: () => {
          this.routeService.employeeCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'Code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'firtName',
            header: 'Firt Name',
            filter: 'text',
            value: (item: any) => {
              return item.firstName;
            }
          }),
          new DataTableColumnText({
            attribute: 'lastName',
            header: 'Last Name',
            filter: 'text',
            value: (item: any) => {
              return item.lastName;
            }
          }),
          new DataTableColumnText({
            attribute: 'companyLocationId',
            header: 'Company Location Id',
            filter: 'text',
            value: (item: any) => {
              return item.company?.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'role',
            header: 'Role',
            filter: 'text',
            value: (item: any) => {
              return item.role;
            }
          }),
          new DataTableColumnText({
            attribute: 'projects',
            header: 'Projects',
            value: (item: any) => {
              return item.projects;
            }
          }),
          new DataTableColumnText({
            attribute: 'vacations',
            header: 'Vacations',
            value: (item: any) => {
              return item.vacations;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View item details',
                onClick: (item: any) => {
                  this.routeService.employeeDetail(item.employeeId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit item',
                onClick: (item: any) => {
                  this.routeService.employeeUpdate(item.employeeId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete item',
                onClick: (item: any) => {
                 
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.employeeService.list(options),
      responseListModelName: 'employees',
    }
  }
}
